var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconRetirada = function SvgIconRetirada(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12.269,
    height: 12.948,
    viewBox: "0 -2 12.269 12.948",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9419",
    "data-name": "Grupo 9419",
    transform: "translate(521.729 -3743.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6330",
    "data-name": "Caminho 6330",
    d: "M-519.293,3743.588a.712.712,0,0,0-.615.3,7.968,7.968,0,0,0-1.044,1.509.462.462,0,0,0,.422.6l7.089.294a.463.463,0,0,0,.419-.23l.845-1.456a.463.463,0,0,0-.378-.694Z",
    transform: "translate(-0.604 -0.254)",
    fill: "#191750"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9418",
    "data-name": "Grupo 9418",
    transform: "translate(-521.729 3744.927)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6331",
    "data-name": "Caminho 6331",
    d: "M-514.023,3758.579l-6.34-.215a.5.5,0,0,0-.512.443l-.851,7.621a.5.5,0,0,0,.418.547l1.428.225,2.96.465,2.513.4a.8.8,0,0,0,.732-.129.722.722,0,0,0,.158-.562l-.023-.393-.063-1.1-.169-2.931-.164-2.842-.086-1.491Z",
    transform: "translate(521.729 -3756.736)",
    fill: "#191750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6332",
    "data-name": "Caminho 6332",
    d: "M-477.731,3759.407l-1.664-9.151-.994,1.615a.5.5,0,0,1-.128.134l.511,8.892a.3.3,0,0,0,.487.223l1.6-1.229A.5.5,0,0,0-477.731,3759.407Z",
    transform: "translate(488.991 -3750.256)",
    fill: "#191750"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconRetirada, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_retirada.43739289.svg";
export { ForwardRef as ReactComponent };